import useFooterType from "@/hooks/useFooterType";

const date = new Date().getFullYear();

interface FooterProps {
    className?: string;
}

const Footer = ({ className = "custom-class" }: FooterProps) => {
    const [footerType] = useFooterType();

    const footerclassName = () => {
        switch (footerType) {
            case "sticky":
                return "sticky bottom-0 z-sticky";
            case "static":
                return "static";
            case "hidden":
                return "hidden";
        }
    };

    return (
        <footer className={className + " " + footerclassName()}>
            <div className="site-footer px-6 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-300 py-4">
                <div className="grid md:grid-cols-2 grid-cols-1 md:gap-5">
                    <div className="text-center ltr:md:text-start rtl:md:text-right text-sm uppercase">
                        COPYRIGHT &copy; {date} CCLCS, All rights Reserved
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
